import { Component, input, computed } from '@angular/core';
import { CommonModule } from "@angular/common";

@Component({
  selector: 'energy-label',
  templateUrl: './energy-label.component.html',
  styleUrl: './energy-label.component.scss',
  imports: [CommonModule]
})
export class EnergyLabelComponent {
  energyRating = input.required<IEnergyRating>();

  energyRatingSummary = computed(() => {
    if (this.energyRating()) {
      return this.calcSummary(this.energyRating());
    }

    return null;
  });

  private calcSummary(er: IEnergyRating): IEnergyRatingSummary {
    const min = !(er.energyLabelMin === null || er.energyLabelMin === "ukjent" || er.energyLabelMin === "unknown");
    const median = !(er.energyLabelMedian === null || er.energyLabelMedian === "ukjent" || er.energyLabelMedian === "unknown");
    const max = !(er.energyLabelMax === null || er.energyLabelMax === "ukjent" || er.energyLabelMax === "unknown");
    
    return {
      min: min,
      median: median,
      max: max,
      all: min && median && max
    }
  }
}

export interface IEnergyRatingSummary {
  min: boolean,
  max: boolean,
  median: boolean,
  all: boolean;
}
export interface IEnergyRating {
  energyLabelPercentageShare: number;
  energyLabelMin: string;
  energyLabelMax: string;
  energyLabelMedian: string;
  energyLabelColorMin: string;
  energyLabelColorMax: string;
  energyLabelColorMedian: string;
  energyColorClassMin?: string;
  energyColorClassMax?: string;
  energyColorClassMedian?: string;
  hasExpiredEnergyLabel?: boolean;
  energyLabelsIsExpired?: boolean;
}
